export default __webpack_public_path__ + "static/media/Levels-Restobar-Bengaluru.276c50fd.jpg";